module.exports = __webpack_public_path__ + "images/38c416f0868c92a2fd0d3292d206cc66871298270f80d36e75f164c92d9f108f.svg";